import { createAction } from '@reduxjs/toolkit'

export const addSheet = createAction('sheets/addSheet')
export const addTableSheet = createAction('sheets/addTableSheet')
export const addListSheet = createAction('sheets/addListSheet')
export const copyTableOrSimpleLoopSheet = createAction('sheets/copyTableOrSimpleLoopSheet')
export const updateSheet = createAction('sheets/updateSheet')
export const deleteSheet = createAction('sheets/deleteSheet')
export const deleteChildSheet = createAction('sheets/deleteChildSheet')
export const deleteLoopSheet = createAction('sheets/deleteLoopSheet')
export const copySheet = createAction('sheets/copySheet')
export const splitSheet = createAction('sheets/splitSheet')
export const editSheet = createAction('sheets/editSheet')
export const convertToLoopScreen = createAction('sheets/convertToLoopScreen')
export const promoteToLoopScreen = createAction('sheets/promoteToLoopScreen')
export const convertToTableScreen = createAction('sheets/convertToTableScreen')
export const promoteToTableScreen = createAction('sheets/promoteToTableScreen')
export const updateSheetSection = createAction('sheets/updateSheetSection')
export const convertListToScreen = createAction('sheets/convertListToScreen')
export const convertScreenToList = createAction('sheets/convertScreenToList')